import React, { FC } from 'react';
import cls from 'classnames';
import { PartialSheetProps, ContentPadding } from './PartialSheet.types';
import { useSheet } from '../../../utilities/useSheet';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import { XIcon } from '@stashinvest/react-assets';
import ButtonIcon from '../../button/buttonIcon';

export const classNames = getClassNames('sds-partial-sheet', [
	'partial-sheet-overlay',
	'partial-sheet-container',
	'partial-sheet-nav',
	'partial-sheet-content',
	'partial-sheet-bottom',
]);

const mapPaddingToClassName: Record<ContentPadding, string> = {
	none: 'p-contentNone',
	small: 'py-contentXS px-contentSmall',
	medium: 'py-contentSmall px-contentMedium',
};

const PartialSheet: FC<PartialSheetProps> = (props) => {
	const {
		children,
		StickyBoxBottom,
		onClose = () => {},
		className,
		contentPadding = 'medium',
		isDismissable = true,
	} = props;
	const { isClosing, closeSheet } = useSheet({ onClose, animationTimeout: 200 });

	return (
		<div
			className={cls(getRootClassListFromProps(classNames, props), className, {
				isClosing,
			})}
			data-testid={props['data-testid']}
			role="dialog"
			aria-labelledby={props.labelledBy}
		>
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
			<div
				className={classNames.partialSheetOverlay}
				onClick={isDismissable ? closeSheet : undefined}
			/>
			<div className={classNames.partialSheetContainer} role="document">
				<div className={classNames.partialSheetNav}>
					<ButtonIcon Icon={XIcon} onClick={closeSheet} label="Close sheet" />
				</div>
				<div
					className={cls(
						classNames.partialSheetContent,
						mapPaddingToClassName[contentPadding]
					)}
				>
					{children}
				</div>
				<div className={classNames.partialSheetBottom}>{StickyBoxBottom}</div>
			</div>
		</div>
	);
};

PartialSheet.displayName = 'PartialSheet';

export default PartialSheet;
